export default "__VITE_ASSET__57217a03__"